export interface IWatrChaseImport {
    payTo:string,
    payFrom:string,
    status:string
    sendOn:string,
    deliverBy:string,
    amount:number,
    chaseTransactionNumber:string,
    donorAlias:string, 
    donorAccountLastFour:string,
    comparisonAmount:number
}